import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography
} from '@mui/material';
import { InstructionText, StyledAlert } from './styles';

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => {
  const [confirmText, setConfirmText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setConfirmText('');
    onClose();
  };

  const handleConfirm = async () => {
    if (confirmText.toLowerCase() === 'delete') {
      setLoading(true);
      try {
        await onConfirm();
        handleClose();
      } catch (error) {
        console.error('Error deleting API key:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const isConfirmDisabled = confirmText.toLowerCase() !== 'delete' || loading;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete API Key</DialogTitle>
      <DialogContent>
        <StyledAlert severity="error">
          <Typography variant="body2">
            <strong>Warning:</strong>
            {' '}
            This action cannot be undone. Any applications
            using this API key will lose access immediately.
          </Typography>
        </StyledAlert>

        <Typography variant="body1" gutterBottom>
          Are you sure you want to delete this API key?
        </Typography>

        <InstructionText
          variant="body2"
          color="text.secondary"
        >
          Type
          {' '}
          <strong>delete</strong>
          {' '}
          to confirm:
        </InstructionText>

        <TextField
          fullWidth
          value={confirmText}
          onChange={e => setConfirmText(e.target.value)}
          placeholder="delete"
          autoFocus
          InputProps={{ autoComplete: 'off' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={isConfirmDisabled}
        >
          {loading ? 'Deleting...' : 'Delete API Key'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
